import { render } from "./PasswordPrompt.vue?vue&type=template&id=d2cf801a&scoped=true"
import script from "./PasswordPrompt.vue?vue&type=script&lang=js"
export * from "./PasswordPrompt.vue?vue&type=script&lang=js"

import "./PasswordPrompt.vue?vue&type=style&index=0&id=d2cf801a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2cf801a"]])

export default __exports__